module.exports = __webpack_public_path__ + "static/media/dialogue-triangle.11cc94b5.svg";